import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { BluetoothPrintService, BtDevice } from '../../core/services/bluetooth-print.service';

@Component({
  selector: 'app-bt-printer-picker',
  templateUrl: './bt-printer-picker.component.html',
  styleUrls: ['./bt-printer-picker.component.scss'],
})
export class BtPrinterPickerComponent implements OnChanges {
  @Input()  visible = false;
  @Output() closed         = new EventEmitter<void>();
  @Output() deviceSelected = new EventEmitter<string>();

  devices: BtDevice[] = [];
  loading = false;
  error   = '';

  constructor(public btService: BluetoothPrintService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']?.currentValue === true && this.btService.isNative) {
      this.loadDevices();
    }
  }

  get savedAddress(): string | null {
    return this.btService.getStoredAddress();
  }

  get savedWebBtId(): string | null {
    return localStorage.getItem(this.btService.WEB_BT_DEVICE_ID_KEY);
  }

  private async loadDevices(): Promise<void> {
    this.loading = true;
    this.error   = '';
    try {
      this.devices = await this.btService.getClassicDevices();
    } catch {
      this.error = 'Bluetooth unavailable or permission denied.';
    } finally {
      this.loading = false;
    }
  }

  selectDevice(device: BtDevice): void {
    this.btService.storeAddress(device.address);
    this.deviceSelected.emit(device.address);
    this.close();
  }

  reset(): void {
    this.btService.resetDevice();
    this.close();
  }

  close(): void {
    this.closed.emit();
  }
}
